export const prayerStream = {
  channel_group_community_groups: 'Community Groups',
  channel_group_member_prayer: 'Member Prayer',
  channel_name_formatted: '# {{name}}',
  disclaimer: "Prayers and personal details shared here will remain visible to current and future members, so please share only what you're comfortable having remain part of this community.",
  empty_channel_primary_description: 'This is the beginning of your chat history in #{{name}}.',
  empty_channel_secondary_description: 'Send messages, attachments, links, emojis, and more.',
  go_to_member_center: 'Go to Member Center',
  join_group: 'Join Group',
  members_online_one: '{{count}} Member Online',
  members_online_other: '{{count}} Members Online',
  no_community_groups_header: "You haven't joined any Community Groups",
  no_community_groups_subtext: 'Visit settings to explore and join groups.',
  no_share_events_header: 'You have no Share Events',
  prayer_stream: 'PrayerStream',
  reaction_like_emoji: '👍',
  reaction_like_name: 'Like',
  reaction_love_emoji: '❤️',
  reaction_love_name: 'Love',
  reaction_pray_emoji: '🙏',
  reaction_pray_name: 'Pray',
  reaction_sad_emoji: '😔',
  reaction_sad_name: 'Sad',
  reaction_wow_emoji: '😲',
  reaction_wow_name: 'Amazed',
  replies_one: '{{count}} reply',
  replies_other: '{{count}} replies',
  send_a_message: 'Send a message',
  share_events: 'Share Events',
  thread: 'Thread',
} as const;

export type PrayerStreamNamespace = Record<keyof typeof prayerStream, string>;
